import React from "react";
import SubmittedCopyright from "../sumitted_copyright/SubmittedCopyright";

const HearingApprovedCopyright = () => {
  const fileStatus = 20;
  const applicationPath = {
    copyright: "/admin/hearing-approved-copyright",
    agreement: "/admin/hearing-approved-agreement",
  };
  const detailsRoute = "/admin/hearing-copyright-details";
  const pageTitle = "শুনানীর চিঠি (অনুমোদিত)";
  return (
    <SubmittedCopyright
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={detailsRoute}
      pageTitle={pageTitle}
    />
  );
};

export default HearingApprovedCopyright;
